import { DateTime } from 'luxon';

export function isWeekday(d: DateTime): boolean {
  return d?.weekday < 6;
}

export function isTodayOrOnwards(d: DateTime): boolean {
  return d >= DateTime.utc().startOf('day');
}

export function isTodayOrBefore(d: DateTime): boolean {
  return d <= DateTime.utc().startOf('day');
}

/**
 * Returns the last business day.
 * That is the previous day that is not Fri/Sat
 */
export function getLastBusinessDay(currentDate?: DateTime): DateTime {
  let date = currentDate
    ? currentDate.minus({ days: 1 }).startOf('day')
    : DateTime.utc().minus({ days: 1 }).startOf('day');
  while (!isWeekday(date)) {
    date = date.minus({ days: 1 });
  }
  return date;
}

/**
 * Returns the next business day.
 * That is the next day that is not Fri/Sat
 */
export function getNextBusinessDay(currentDate: DateTime = DateTime.utc().plus({ days: 1 }).startOf('day')): DateTime {
  let date = currentDate.plus({ days: 1 }).startOf('day');
  while (!isWeekday(date)) {
    date = date.plus({ days: 1 });
  }
  return date;
}

export function getUtcDate(date: string): DateTime {
  return DateTime.fromISO(date).toUTC().startOf('day');
}

export function getUniversalTicks(dataTime: DateTime): number {
  return dataTime.toMillis() * 10000 + 621355968000000000;
}

export function getDatesWithinRange(
  startDate: string,
  stopDate: string,
  direction: 'asc' | 'desc',
  onlyWorkingDays?: boolean
): string[] {
  let datesWithingRange = [];
  let startUtc = DateTime.fromISO(startDate);
  let stopUtc = DateTime.fromISO(stopDate);

  if (direction === 'asc') {
    while (startUtc <= stopUtc) {
      if (!onlyWorkingDays || isWeekday(startUtc)) {
        datesWithingRange.push(startUtc.toISODate());
      }

      startUtc = startUtc.plus({ days: 1 });
    }
  } else {
    while (startUtc >= stopUtc) {
      if (!onlyWorkingDays || isWeekday(startUtc)) {
        datesWithingRange.push(startUtc.toISODate());
      }

      startUtc = startUtc.minus({ days: 1 });
    }
  }

  return datesWithingRange;
}

export function formatISODate(date: string, toFormat: string) {
  return DateTime.fromISO(date, { zone: 'UTC' }).toFormat(toFormat);
}

export function formattedDate(formatDate: string) {
  const date = DateTime.fromISO(formatDate, { zone: 'UTC' });
  return formatDate ? [date.day, date.month, date.year].map((n) => (n < 10 ? `0${n}` : `${n}`)).join('-') : '';
}

export function addBusinessDays(days: number, dateToCountFrom: DateTime = DateTime.now()): DateTime {
  let i = 0;
  let latestDate = dateToCountFrom;
  let daysToAdd = 0;
  while (days !== i) {
    i++;
    const { weekday } = latestDate;
    if (weekday === 5) {
      daysToAdd += 3;
    } else if (weekday === 6) {
      daysToAdd += 2;
    } else daysToAdd++;
    latestDate = latestDate.plus({ days: daysToAdd });
  }
  return dateToCountFrom.plus({ days: daysToAdd });
}

export function removeBusinessDays(days: number, dateToCountFrom: DateTime = DateTime.now()): DateTime {
  let i = 0;
  let latestDate = dateToCountFrom;
  let daysToRemove = 0;
  while (days !== i) {
    i++;
    daysToRemove = 0;
    const { weekday } = latestDate;
    if (weekday === 1) {
      daysToRemove += 3;
    } else if (weekday === 7) {
      daysToRemove += 2;
    } else daysToRemove++;
    latestDate = latestDate.minus({ days: daysToRemove });
  }
  return latestDate;
}
